import { useState } from "react";
import { BiSolidBarChartAlt2 } from "react-icons/bi";
import { FaPlay } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";

import { cn } from "@bentolabs/kit/utils";

import { usePointsAccount } from "shared/api/use-points-account-query";
import { Button } from "shared/ui/button";

import { Leaderboard } from "./leaderboard/leaderboard";

type Props = {
  className?: string;
};

export const PointsLeaderboardCard = (props: Props) => {
  const { className } = props;
  const pointsAccountQuery = usePointsAccount();
  const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false);

  const position = pointsAccountQuery.data?.position;

  if (pointsAccountQuery.isPending)
    return (
      <div
        className={cn(
          "relative flex flex-col overflow-hidden rounded-xl",
          className
        )}
      >
        <Skeleton width="100%" height={165} borderRadius={12} />
      </div>
    );

  return (
    <div
      className={cn(
        "bg-baltic-sea/30 relative flex w-full flex-col overflow-hidden rounded-xl",
        className
      )}
    >
      <div className="flex items-center bg-white/2 px-4 py-3.5">
        <div className="flex items-center gap-x-3">
          <div className="bg-onyx flex size-8 items-center justify-center rounded-lg">
            <BiSolidBarChartAlt2 className="text-spearmint drop-shadow-spearmint/30 size-5 drop-shadow-md" />
          </div>

          <span className="text-lg text-white">Leaderboard Rank</span>
        </div>
      </div>

      <div className="flex items-end justify-between px-5.5 pt-5.5 pb-4.5">
        <div className="text-6xl">{position}</div>

        <Button
          variant="spearmint"
          onClick={() => {
            setIsLeaderboardOpen(true);
          }}
        >
          View Leaderboard{" "}
          <div className="flex size-6 items-center justify-center">
            <FaPlay className="size-3" />
          </div>
        </Button>
      </div>
      <Leaderboard
        isOpen={isLeaderboardOpen}
        onOpenChange={setIsLeaderboardOpen}
      />
    </div>
  );
};
